module.exports = __webpack_public_path__ + "static/media/story-house-logo.6886817a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/story-house-logo.png
// module id = 157
// module chunks = 0